import { controls, currencyToNumber, grouped } from "../../controls";

const rpad14 = {
  label: "Recompliance",
  starting: true,
  url: "rp101m",
  pageLabel: "Recompliance",
  pageType: "history",
  // filteraction: true,
  filter: [
  ],
  form: [],
  history: {
    perPage: 50,
    reportHeader: "Recompliance",
    filterable: true,
    sortable: true,
    defaultsTo: 0,
    pivotable: true,
    pdfProps: { pageSize: "A4", pageOrientation: "portrait" },
    extraRows: {
      location: "top",
      fields: ["observation_type"],
      subtotals: {
        by: "branch_display",
        displayIn: "observation_type",
        subtotals: {
          by: "insgroup",
          displayIn: "observation_type",
        }
      }
      // grandtotal: { type: "fixed", displayIn: "pacs_name", val: "Grand Total", count: true },
    },

    displayColumns: [
      {
        Header: "Sr", type: "autoinc", accessor: "srno", align: "center", width: 30,
        width132: { size: 3 }
      },
      // {
      //   Header: "Branch",
      //   accessor: "branch_display",
      //   rwidth: "*"
      // },
      {
        Header: "Observation",
        accessor: "observation_type"
      },
      {
        Header: "Inspection Date",
        accessor: "date",
        type: "date"
      },
      {
        Header: "Status",
        accessor: "inspection_status"
      },
      {
        Header: "Remark",
        accessor: "remark"
      },
      {
        Header: "Complete By",
        accessor: "complete_by",
        type: "date"
      }
    ]
  }
};

export default rpad14;